var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77977 7.80102C6.29842 8.86135 7.15792 9.71695 8.2206 10.2308C8.29835 10.2676 8.38436 10.2836 8.47015 10.2771C8.55595 10.2706 8.63857 10.2419 8.7099 10.1937L10.2746 9.15034C10.3438 9.1042 10.4234 9.07605 10.5063 9.06844C10.5891 9.06083 10.6725 9.074 10.749 9.10677L13.6763 10.3613C13.7757 10.4036 13.8588 10.477 13.9128 10.5705C13.9669 10.664 13.9892 10.7726 13.9762 10.8799C13.8837 11.6039 13.5304 12.2693 12.9826 12.7516C12.4347 13.2339 11.7299 13.5 11 13.5001C8.74566 13.5001 6.58365 12.6045 4.98959 11.0105C3.39553 9.41641 2.5 7.2544 2.5 5.00006C2.50004 4.27017 2.76612 3.56532 3.24843 3.01748C3.73073 2.46965 4.39618 2.1164 5.12019 2.02387C5.22745 2.01089 5.33602 2.03312 5.42955 2.08721C5.52307 2.1413 5.59649 2.22432 5.63873 2.32376L6.89439 5.25363C6.92687 5.32941 6.9401 5.41205 6.93291 5.49419C6.92572 5.57632 6.89833 5.65541 6.85318 5.7244L5.81341 7.31313C5.76608 7.3846 5.73811 7.46712 5.73221 7.55263C5.72631 7.63815 5.7427 7.72373 5.77977 7.80102Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fb1b603eb153297e9c3fd21e678bfa93.svg";
export { ForwardRef as ReactComponent };